(() => {
  const HUB_PATHS = {
    'Nail Gels': '/pages/nail-gels',
    'Nail Art': '/pages/nail-art',
    'Nail Essentials': '/pages/nail-essentials',
    'Lash & Brow': '/pages/lash-brow',
    'Disinfectants & Liquids': '/pages/disinfectants-liquids',
    Equipment: '/pages/equipment',
    'Health & Beauty': '/pages/health-beauty',
    'Mani & Pedi': '/pages/mani-pedi',
    'Sugaring & Waxing': '/pages/sugaring-waxing',
    'Spa Misc': '/pages/spa-misc',
    Retail: '/pages/retail'
  };

  const getDirectLink = (item) =>
    Array.from(item.children).find(
      (child) => child.matches && child.matches('a.tmenu_item_link')
    );

  const getLabel = (link) =>
    link?.querySelector('.tmenu_item_text')?.textContent.trim() || '';

  const MOBILE_MENU_STYLE_ID = 'nove-qikify-mobile-readable-links';

  const applyMobileMenuReadableStyles = () => {
    if (document.getElementById(MOBILE_MENU_STYLE_ID) || !document.head) return;

    const style = document.createElement('style');
    style.id = MOBILE_MENU_STYLE_ID;
    style.textContent = `
      @media screen and (max-width: 767px) {
        #qikify-tmenu-mobilemenu a.tmenu_item_link,
        #qikify-tmenu-mobilemenu a.tmenu_item_link .tmenu_item_text,
        #qikify-tmenu-mobilemenu a.tmenu_item_link .tmenu_indicator {
          color: #1a1a1a !important;
          -webkit-text-fill-color: currentColor !important;
        }

        #qikify-tmenu-mobilemenu li.tmenu_item_active > a.tmenu_item_link,
        #qikify-tmenu-mobilemenu li.tmenu_item_active > a.tmenu_item_link .tmenu_item_text,
        #qikify-tmenu-mobilemenu li.tmenu_item_active > a.tmenu_item_link .tmenu_indicator {
          color: #ec008c !important;
        }

        #qikify-tmenu-mobilemenu .tmenu_indicator_icon,
        #qikify-tmenu-mobilemenu .tmenu_indicator_icon svg,
        #qikify-tmenu-mobilemenu .tmenu_indicator_icon path {
          color: inherit !important;
          fill: currentColor !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const applyDesktopHubLinks = () => {
    document
      .querySelectorAll(
        'nav.tmenu_app--horizontal > .tmenu_nav > li.tmenu_item_level_0'
      )
      .forEach((item) => {
        const link = getDirectLink(item);
        const path = HUB_PATHS[getLabel(link)];

        if (!link || !path) return;

        link.setAttribute('href', path);
        link.removeAttribute('tmenu-disabled-link');
        link.dataset.noveHubPath = path;
      });
  };

  const createMobileViewAll = (path) => {
    const item = document.createElement('li');
    item.className =
      'tmenu_item tmenu_item_level_1 tmenu_item_submenu_type_automatic tmenu_item_mobile tmenu_item_layout tmenu_item_layout_text nove-hub-view-all';

    const link = document.createElement('a');
    link.className = 'tmenu_item_link';
    link.href = path;
    link.target = '_self';
    link.title = 'View All';

    const text = document.createElement('span');
    text.className = 'tmenu_item_text';
    text.textContent = 'View All';

    link.appendChild(text);
    item.appendChild(link);
    return item;
  };

  const applyMobileViewAllLinks = () => {
    document
      .querySelectorAll('#qikify-tmenu-mobilemenu > li.tmenu_item_level_0')
      .forEach((item) => {
        const rootLink = getDirectLink(item);
        const path = HUB_PATHS[getLabel(rootLink)];

        if (!path) return;

        const submenu = Array.from(item.children).find(
          (child) =>
            child.matches &&
            child.matches('ul.tmenu_submenu')
        );

        if (!submenu) return;

        const existingViewAll = Array.from(submenu.children).find((child) => {
          const link = getDirectLink(child);
          return getLabel(link).toLowerCase() === 'view all';
        });

        if (existingViewAll) {
          const existingLink = getDirectLink(existingViewAll);
          existingLink?.setAttribute('href', path);
          existingLink?.setAttribute('title', 'View All');

          const existingText = existingLink?.querySelector('.tmenu_item_text');
          if (existingText && existingText.textContent.trim() !== 'View All') {
            existingText.textContent = 'View All';
          }
          return;
        }

        submenu.appendChild(createMobileViewAll(path));
      });
  };

  let updateScheduled = false;

  const applyHubNavigation = () => {
    updateScheduled = false;
    applyMobileMenuReadableStyles();
    applyDesktopHubLinks();
    applyMobileViewAllLinks();
  };

  const scheduleHubNavigation = () => {
    if (updateScheduled) return;
    updateScheduled = true;
    window.queueMicrotask(applyHubNavigation);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!window.matchMedia('(min-width: 768px)').matches) return;

      const link = event.target.closest(
        'nav.tmenu_app--horizontal > .tmenu_nav > li.tmenu_item_level_0 > a.tmenu_item_link[data-nove-hub-path]'
      );

      if (!link || event.target.closest('.tmenu_indicator')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.dataset.noveHubPath);
    },
    true
  );

  const observer = new MutationObserver(scheduleHubNavigation);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHubNavigation, {
      once: true
    });
  } else {
    scheduleHubNavigation();
  }

  window.addEventListener('pageshow', scheduleHubNavigation);
})();
